<template>
  <div class="d-flex text-center justify-center align-center fullscreen">
    <Loading />

    <Suspense>
      <div class="pa-8">
        <router-view v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
      </div>
    </Suspense>
  </div>
</template>

<script setup lang="ts">
import Loading from '@/components/general/app-loading.vue'
</script>
